var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRecruitJob(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_12919",
    "data-name": "Group 12919",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 36.27,
    height: 32,
    viewBox: "0 0 36.27 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2467",
    "data-name": "Rectangle 2467",
    width: 36.27,
    height: 32,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12918",
    "data-name": "Group 12918",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12926",
    "data-name": "Path 12926",
    d: "M36.27,8.354v6.021a5.377,5.377,0,0,1-1.2,2.519.924.924,0,0,0-.207.556c-.012,3.706-.008,7.412-.009,11.118A3.207,3.207,0,0,1,31.425,32H4.835a3.205,3.205,0,0,1-3.414-3.411q0-5.577-.009-11.153a.88.88,0,0,0-.194-.526A4.742,4.742,0,0,1,0,13.676c.017-1.546,0-3.092,0-4.638A3.188,3.188,0,0,1,3.4,5.65q2.532,0,5.063,0h.4c0-.781,0-1.512,0-2.242A3.319,3.319,0,0,1,12.174.018q5.966-.039,11.932,0a3.25,3.25,0,0,1,3.25,2.836,16.1,16.1,0,0,1,.059,2.013c0,.254,0,.508,0,.784h.475c1.747,0,3.494-.014,5.24.008a3.152,3.152,0,0,1,3.061,2.471c.019.077.051.15.078.226M21.82,19.164A31.717,31.717,0,0,0,29.645,17.7a10.017,10.017,0,0,0,3.415-1.812,2.9,2.9,0,0,0,1.1-2.381c-.039-1.51-.009-3.021-.011-4.532a1.068,1.068,0,0,0-1.17-1.2q-14.836,0-29.671,0A1.068,1.068,0,0,0,2.13,8.968c0,1.522.025,3.046-.01,4.567a2.843,2.843,0,0,0,.989,2.251,7.935,7.935,0,0,0,2.238,1.4,22.423,22.423,0,0,0,5.709,1.572c1.114.172,2.237.288,3.4.434,0-.358,0-.65,0-.943a1.049,1.049,0,0,1,1.1-1.124q2.585-.012,5.169,0a1.049,1.049,0,0,1,1.1,1.123c0,.293,0,.585,0,.912m10.908-.46a1.354,1.354,0,0,0-.145.049,18.915,18.915,0,0,1-5.348,1.78c-1.657.3-3.334.485-5,.726-.211.031-.451-.046-.553.293a3.406,3.406,0,0,1-3.049,2.562,3.585,3.585,0,0,1-4.023-2.5.419.419,0,0,0-.426-.357c-.927-.091-1.855-.18-2.779-.3A24.567,24.567,0,0,1,4.3,19.036c-.241-.111-.48-.226-.751-.354v.369q0,4.78,0,9.561A1.107,1.107,0,0,0,4.8,29.874H31.467a1.106,1.106,0,0,0,1.261-1.258q0-2.921,0-5.843ZM25.291,5.634c0-.71,0-1.382,0-2.054a1.266,1.266,0,0,0-1.455-1.446H15.623c-1.109,0-2.218,0-3.328,0a1.164,1.164,0,0,0-1.275.988C10.957,3.951,11,4.787,11,5.634ZM16.579,19.267c0,.471-.008.916,0,1.361a1.386,1.386,0,0,0,1.332,1.381c.956.068,1.649-.356,1.75-1.149a12.758,12.758,0,0,0,.013-1.594Z",
    transform: "translate(0 0.001)",
    fill: "#600097"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecruitJob);
export default __webpack_public_path__ + "static/media/recruitJob.8b87aaf62328a7e2ad554e638148d873.svg";
export { ForwardRef as ReactComponent };